import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Register from './pages/Register';
import Login from './pages/Login';
import Index from './pages';
import EmployeeLogin from './pages/employeeLogin';
import Booking from './pages/booking';
import AddBusinessDetail from './pages/AddBusinessDetail';
import UpdateBusinessDetail from './pages/UpdateBusinessDetail';
import SendEmail from './pages/SendEmail';
import ResetPasswordRequest from './pages/ResetPasswordRequest';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SendsesEmail from './pages/emailApi';
import CheckoutPage from './pages/CheckoutPage';
import EmployeeWorkingHours from './pages/EmployeeWorkingHours';

// Redirects to /dashboard if already logged in
function PublicOnlyRoute({ children }) {
  return localStorage.getItem('token')
    ? <Navigate to="/dashboard" replace />
    : children;
}

// Redirects to /login if not logged in
function PrivateRoute({ children }) {
  return localStorage.getItem('token')
    ? children
    : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public-only routes: logged-in users are bounced to /dashboard */}
        <Route path="/login"    element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
        <Route path="/register" element={<PublicOnlyRoute><Register /></PublicOnlyRoute>} />
        <Route path="/Emplogin" element={<PublicOnlyRoute><EmployeeLogin /></PublicOnlyRoute>} />

        {/* Truly public routes (no auth context needed) */}
        <Route path="/emailApi"           element={<SendsesEmail />} />
        <Route path="/booking"            element={<Booking />} />
        <Route path="/booking/:businessId" element={<Booking />} />
        <Route path="/send-mail"          element={<SendEmail />} />
        <Route path="/forgot-password"    element={<ResetPasswordRequest />} />
        <Route path="/reset-password"     element={<ResetPasswordPage />} />
        <Route path="/checkout"           element={<CheckoutPage />} />

        {/* Protected standalone pages */}
        <Route path="/business_detail"       element={<PrivateRoute><AddBusinessDetail /></PrivateRoute>} />
        <Route path="/ubd"                   element={<PrivateRoute><UpdateBusinessDetail /></PrivateRoute>} />
        <Route path="/employee-working-hours" element={<PrivateRoute><EmployeeWorkingHours /></PrivateRoute>} />

        {/* Root: redirect to /dashboard (PrivateRoute handles unauthenticated → /login) */}
        <Route path="/" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />

        {/* All app views — rendered inside the Index shell */}
        <Route path="/*" element={<PrivateRoute><Index /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
